import React, { SVGProps } from "react"

function PlayStore(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 48"
      {...props}
    >
      <path
        d="M5.926 47.017h148.148c3.006 0 5.47-2.467 5.47-5.479V5.934c0-3.011-2.464-5.478-5.47-5.478H5.926C2.92.456.456 2.923.456 5.934V41.54c0 3.01 2.464 5.478 5.47 5.478z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.729}
      />
      <path
        d="M56.41 12.485c0 .982-.297 1.768-.883 2.354-.674.696-1.55 1.045-2.626 1.045-1.028 0-1.905-.355-2.625-1.056-.72-.712-1.08-1.585-1.08-2.63s.36-1.918 1.08-2.623c.72-.707 1.597-1.063 2.625-1.063.511 0 1 .105 1.465.299.464.195.841.46 1.115.786l-.622.62c-.477-.557-1.127-.832-1.958-.832-.75 0-1.4.259-1.951.78-.546.524-.82 1.202-.82 2.033 0 .832.274 1.516.82 2.039.552.516 1.201.78 1.951.78.795 0 1.465-.264 1.993-.786.348-.345.545-.822.597-1.43h-2.59v-.85h3.456c.041.184.053.362.053.534zM61.893 9.54h-3.246v2.233h2.927v.85h-2.927v2.234h3.246v.866h-4.165v-7.05h4.165v.866zM65.763 15.723h-.92V9.539h-1.99v-.865h4.902v.865h-1.992v6.184zM71.303 15.723v-7.05h.918v7.05h-.918zM76.288 15.723h-.912V9.539h-1.998v-.865h4.909v.865h-1.999v6.184zM87.569 14.816c-.704.713-1.575 1.068-2.615 1.068-1.045 0-1.916-.355-2.62-1.068-.702-.711-1.051-1.584-1.051-2.618 0-1.033.35-1.906 1.051-2.617.704-.713 1.575-1.069 2.62-1.069 1.034 0 1.906.356 2.609 1.075.708.717 1.057 1.584 1.057 2.611 0 1.034-.35 1.907-1.051 2.618zm-4.555-.59c.53.527 1.173.791 1.94.791.762 0 1.412-.264 1.935-.792.528-.527.796-1.205.796-2.027 0-.821-.268-1.499-.796-2.026-.523-.528-1.173-.793-1.934-.793-.768 0-1.412.265-1.941.793-.528.527-.796 1.205-.796 2.026 0 .822.268 1.5.796 2.027zM89.91 15.723v-7.05h1.115l3.468 5.483h.04l-.04-1.355V8.674h.917v7.049h-.958L90.821 9.97h-.04l.04 1.361v4.392h-.912z"
        fill="#000"
        stroke="#000"
        strokeWidth={0.156}
        strokeMiterlimit={10}
      />
      <path
        d="M81.057 26.017c-2.794 0-5.077 2.102-5.077 5.002 0 2.876 2.283 5 5.077 5 2.8 0 5.083-2.124 5.083-5 0-2.9-2.283-5.002-5.083-5.002zm0 8.032c-1.533 0-2.852-1.25-2.852-3.03 0-1.804 1.319-3.033 2.852-3.033s2.858 1.23 2.858 3.032c0 1.78-1.325 3.031-2.858 3.031zM69.98 26.017c-2.8 0-5.077 2.102-5.077 5.002 0 2.876 2.277 5 5.077 5 2.799 0 5.077-2.124 5.077-5 0-2.9-2.278-5.002-5.077-5.002zm0 8.032c-1.535 0-2.858-1.25-2.858-3.03 0-1.804 1.323-3.033 2.858-3.033 1.533 0 2.852 1.23 2.852 3.032 0 1.78-1.319 3.031-2.852 3.031zm-13.181-6.5v2.126h5.135c-.15 1.188-.552 2.06-1.168 2.67-.75.734-1.917 1.55-3.967 1.55-3.16 0-5.635-2.52-5.635-5.644 0-3.123 2.475-5.644 5.635-5.644 1.708 0 2.951.66 3.869 1.515l1.515-1.497c-1.283-1.211-2.99-2.142-5.384-2.142-4.334 0-7.975 3.485-7.975 7.768 0 4.283 3.641 7.768 7.975 7.768 2.342 0 4.1-.759 5.484-2.181 1.417-1.401 1.859-3.37 1.859-4.96 0-.495-.042-.949-.116-1.328h-7.227zm53.9 1.649c-.418-1.119-1.707-3.181-4.334-3.181-2.602 0-4.769 2.027-4.769 5.002 0 2.8 2.145 5 5.019 5 2.325 0 3.666-1.401 4.218-2.217l-1.725-1.136c-.576.832-1.36 1.383-2.493 1.383-1.125 0-1.933-.51-2.45-1.515l6.767-2.768-.233-.568zm-6.9 1.665c-.058-1.929 1.515-2.916 2.642-2.916.884 0 1.633.436 1.883 1.06l-4.525 1.856zm-5.5 4.851h2.224V21.017h-2.225v14.697zm-3.644-8.583h-.075c-.5-.585-1.452-1.114-2.66-1.114-2.534 0-4.85 2.199-4.85 5.018 0 2.802 2.316 4.984 4.85 4.984 1.208 0 2.16-.534 2.66-1.136h.075v.717c0 1.912-1.034 2.94-2.7 2.94-1.36 0-2.203-.97-2.551-1.786l-1.935.798c.558 1.325 2.035 2.957 4.485 2.957 2.609 0 4.81-1.517 4.81-5.208v-8.98h-2.11v.81zm-2.544 6.918c-1.534 0-2.817-1.268-2.817-3.014 0-1.763 1.283-3.049 2.817-3.049 1.51 0 2.701 1.286 2.701 3.049 0 1.746-1.19 3.014-2.701 3.014zm29.003-13.032h-5.321v14.697h2.219v-5.569h3.102c2.464 0 4.881-1.762 4.881-4.565 0-2.801-2.423-4.563-4.881-4.563zm.058 7.084h-3.16v-5.04h3.16a2.565 2.565 0 012.603 2.52c0 1.137-.946 2.52-2.603 2.52zm13.715-2.112c-1.603 0-3.27.7-3.955 2.25l1.969.816c.423-.816 1.203-1.08 2.027-1.08 1.151 0 2.318.683 2.336 1.89v.154c-.402-.23-1.261-.569-2.319-.569-2.12 0-4.281 1.154-4.281 3.307 0 1.97 1.737 3.238 3.69 3.238 1.493 0 2.316-.666 2.834-1.44h.076v1.136h2.143v-5.638c0-2.606-1.969-4.064-4.52-4.064zm-.267 8.054c-.726 0-1.737-.355-1.737-1.245 0-1.137 1.261-1.574 2.352-1.574.977 0 1.435.213 2.029.494-.174 1.361-1.359 2.325-2.644 2.325zm12.594-7.732l-2.551 6.371h-.075l-2.637-6.371h-2.393l3.962 8.904-2.261 4.954h2.319l6.104-13.858h-2.468zm-20 9.403h2.225V21.017h-2.225v14.697z"
        fill="#000"
      />
      <path
        d="M12.414 9.304c-.35.362-.552.925-.552 1.654V36.96c0 .729.202 1.292.552 1.653l.086.08 14.743-14.566v-.344L12.5 9.22l-.086.085z"
        fill="url(#play-store_svg__paint0_linear)"
      />
      <path
        d="M32.152 28.986l-4.909-4.858v-.343l4.915-4.858.11.063 5.82 3.273c1.661.93 1.661 2.458 0 3.392l-5.82 3.268-.116.063z"
        fill="url(#play-store_svg__paint1_linear)"
      />
      <path
        d="M32.268 28.922l-5.025-4.966-14.83 14.658c.553.573 1.452.642 2.475.07l17.38-9.761z"
        fill="url(#play-store_svg__paint2_linear)"
      />
      <path
        d="M32.268 18.99l-17.38-9.76c-1.023-.568-1.922-.499-2.474.074l14.829 14.652 5.025-4.966z"
        fill="url(#play-store_svg__paint3_linear)"
      />
      <defs>
        <linearGradient
          id="play-store_svg__paint0_linear"
          x1={25.934}
          y1={37.231}
          x2={6.202}
          y2={17.268}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="play-store_svg__paint1_linear"
          x1={40.251}
          y1={23.955}
          x2={11.465}
          y2={23.955}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="play-store_svg__paint2_linear"
          x1={29.535}
          y1={21.256}
          x2={2.778}
          y2={-5.816}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="play-store_svg__paint3_linear"
          x1={8.681}
          y1={47.265}
          x2={20.63}
          y2={35.176}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PlayStore
